import { Page } from './pages';

import { PATH } from '../../constants';

export default {
  component: Page,
  name: 'Tenants',
  path: PATH.TENANTS
};
